import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY } from "../../../../operations/queries/operations/queries/get-stores-by-distance.js";
import { mapStoresResult } from "../../adapters/hooks/api/adapters/mapStoresResult.js";
const useStoresByDistanceWithoutInventory = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(
    GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY,
    {
      variables,
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      },
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      onError(error) {
        toast.failed("stores.page.search.getStoresByDistance.error");
        console.error("Failed to fetch store by distance: ", error);
      }
    }
  );
  const { storesByDistance } = queryState.data ?? {};
  const data = React.useMemo(() => mapStoresResult(storesByDistance), [storesByDistance]);
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useStoresByDistanceWithoutInventory as default
};
//# sourceMappingURL=use-stores-by-distance-without-inventory.js.map
